import React from "react";
import ReportLogWoodDetail from "../../components/reports/ReportLogWoodDetail";
import { URL_LOG_WOOD } from "../../constance/urls";
import useDropdownItem from "../../hooks/useDropdownItem";
import { useTranslation } from "react-i18next";
import { formatComma } from "../../utils/stringFormat";

function ReportLogWoodSpeciesByCompanyView() {

  const logWoodSpeciesChoices = useDropdownItem({ url: URL_LOG_WOOD.LOG_WOOD_SPECIES_GRADE });
  const { t } = useTranslation();

  const defaultColumns = [
    {
      title: t("datas.index"),
      dataIndex: "index",
      width: 80,
    },
    {
      title: t("truck_companies.code"),
      dataIndex: "truck_company_code",
      width: 120,
    },
    {
      title: t("truck_companies.name"),
      dataIndex: "truck_company_name",
      width: 220,
    }
  ];

  const [columns, setColumns] = React.useState(defaultColumns);

  React.useEffect(() => {
    if (!logWoodSpeciesChoices.response.length) {
      return;
    }
    setColumns([
      ...defaultColumns,
      ...logWoodSpeciesChoices.response
        .sort((a, b) => (a.name < b.name ? -1 : 1))
        .map((species) => {
          return {
            title: species.name,
            children: [
              {
                title: t("units.tonne"),
                dataIndex: `report.${species.name}_weight`,
                render: (text, record) =>
                  formatComma(record?.report?.[`${species.name}_weight`], 3),
              },
              {
                title: "%",
                dataIndex: `report.${species.name}_percent`,
                render: (text, record) =>
                  formatComma(record?.report?.[`${species.name}_percent`]),
              },
            ],
          };
        }),
      {
        title: t("datas.total"),
        children: [
          {
            title: t("units.tonne"),
            dataIndex: "report.total_weight",
            render: (text, record) => formatComma(record?.report?.total_weight, 3),
          },
          {
            title: "%",
            dataIndex: "report.total_percent",
            render: (text, record) => formatComma(record?.report?.total_percent),
          },
        ],
      },
    ]);
  }, [logWoodSpeciesChoices.response]);


  return (
    <>
      <ReportLogWoodDetail
        title={t('menus.report_menus.log_wood_menus.log_wood_species_by_customer')}
        url={URL_LOG_WOOD.REPORT_LOG_WOOD_SPECIES_CUSTOMER}
        tableColumns={columns}
        exportUrl={URL_LOG_WOOD.REPORT_LOG_WOOD_SPECIES_CUSTOMER_EXPORT}
        hideCustomerFilter
      />
    </>
  )
}

export default ReportLogWoodSpeciesByCompanyView; 